module.exports = __webpack_public_path__ + "img/sns_twitter.5c14852d.png";